import { AppThunk } from '../../../store/rootReducer';
import { trackWaveTag } from '../../analytics/thunks/track-wave-tag.thunk';
import * as waveActions from '../actions/wave.actions';
import { waveListSelector } from '../selectors/wave.selectors';
import { TagLabel } from '../types/tag.type';
import { WaveType } from '../types/wave.type';

export const setWavesTagsForType =
  (tags: TagLabel[], currentType: WaveType): AppThunk =>
  async (dispatch, getState) => {
    const waves = waveListSelector(getState());
    const waveIds = waves
      .filter(({ type }) => type === currentType)
      .map(({ id }) => id);

    dispatch(trackWaveTag(waves[0], tags.join(' '), 'all'));
    dispatch(waveActions.setTags({ waveIds, tags }));
  };
